import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const DEFAULT_TIMEZONE = 'America/New_York';

/** Format a UTC ISO string in the given apartment timezone. */
export function fmtInTz(
  iso: string | undefined | null,
  tz: string | undefined | null,
  fmt: string = 'YYYY-MM-DD HH:mm'
): string {
  if (!iso) return '-';
  const zone = tz || DEFAULT_TIMEZONE;
  return dayjs.utc(iso).tz(zone).format(fmt);
}

/** Short label (e.g. "CST", "PDT") for an IANA timezone using `z` in advancedFormat. */
export function tzLabel(tz: string | undefined | null): string {
  if (!tz) return '';
  try {
    return dayjs().tz(tz).format('z');
  } catch {
    return tz;
  }
}

export {dayjs};
